import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '../components/Index';
import Auth from '../components/Auth';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Index,
  },
  {
    path: '/auth',
    name: 'Auth',
    component: Auth,
  },
];

const router = new VueRouter({
  routes
});

export default router;
